export default __webpack_public_path__ + "static/media/postgresql.40e4ed33.svg";